import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class OrdersAPI {
  static async updateOrder(payload: any) {
    return (await $http.put('/orders/update', payload)).data
  }

  static async refundOrder(orderId: any) {
    return (await $http.post(`/orders/refund/${orderId}`)).data
  }

  static async getSettings(branchId: number) {
    return (await $http.get(`/orders/settings/${branchId}`)).data
  }

  static async getOrder(id: number) {
    return (await $http.get(`/orders/order/${id}`)).data
  }

  static async getOrderHistories(id: number) {
    return (await $http.get(`/orders/order/${id}/history`)).data
  }

  static async getOrderInvoice(id: number) {
    return (await $http.get(`/orders/order/${id}/invoice`)).data
  }

  static async downloadOrder(id: number, download = true) {
    const url = `/orders/order/${id}/invoice?download=1`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    if (download) {
      saveAs(file, `Order-${id}.pdf`)
    }
    return file
  }

  static async printOrder(id: number) {
    const file = await OrdersAPI.downloadOrder(id, false)
    return URL.createObjectURL(file)
  }

  static async reloadDeliveryDetails(deliveryCode: number) {
    return (await $http.get(`/service/delivery/fetch-order/${deliveryCode}`)).data.delivery
  }

  static async exportExcel(branchId: any, filters: any) {
    const url = `/orders/export/${branchId}?${FormsService.prepareQueryString(filters, true)}`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    saveAs(file, 'orders.xlsx')
  }

  static async verifyPayment(id: number) {
    return (await $http.get(`/orders/verify-payment?orderId=${id}`)).data
  }

  public static async addNotes(id: number, body: any) {
    return (await $http.post(`orders/notes/${id}`, body)).data
  }

  public static async unverifiedPaymentsCount() {
    return (await $http.get('orders/unverified-orders/count?only_unverified=1')).data
  }
}

export default OrdersAPI
